
import { MDB_TYPES as TYPES } from "@meddbriefer/scenario-data/constants.js"

import { useScenario } from "../contexts/ScenarioContext"

import CheckBox from "./CheckBox"
import CallOutText from "./CallOutText"
import CallOutIcon from "./icons/CallOutIcon"

const getLabel = (item) => {
    if  ("abbrLabel" in item && "" !== item.abbrLabel) {
        return item.abbrLabel
    } else {
        return item.label
    }
}

const CheckListItem = ({step}) => {
    const {
        // scenario,
        isChecked,
        setChecked,
        toggleChecklistItem,
        toggleAssessmentItem,
        setCurrentAssessmentFinding,
    } = useScenario()


    const assessmentClickHandler = (item) => {
        toggleAssessmentItem(item)
        setCurrentAssessmentFinding(item.id)
    }

    const deselectOtherRadios = (selectedID, radioGroup) => {

        const otherOptionIDs = radioGroup.options.map(item => item.id).filter(id => id !== selectedID)
        otherOptionIDs.forEach(otherID => setChecked(otherID, false))
    }

    const awoClickHandler = (event, radioGroup, selectedRadio) => {
        const selectedID = selectedRadio.id
        deselectOtherRadios(selectedID, radioGroup)
        toggleAssessmentItem(selectedRadio)
        setCurrentAssessmentFinding(selectedID)
    }

    const decisionClickHandler = (event, radioGroup, selectedRadio) => {
        const selectedID = selectedRadio.id
        deselectOtherRadios(selectedID, radioGroup)
        toggleChecklistItem(selectedRadio)
    }

    // const radioClickHandler = (event, radioGroup, selectedRadio) => {
    //     const selectedID = selectedRadio.id
    //     deselectOtherRadios(selectedID, radioGroup)
    //     // const otherOptionIDs = radioGroup.items.map(item => item.id).filter(id => id !== selectedID)
    //     // console.log("selectedID", selectedID)
    //     // console.log("otherOptionIDs", otherOptionIDs)
    //     // console.log("currentTargetValue", event.currentTarget.value)
    //     // otherOptionIDs.forEach(otherID => setChecked(otherID, false))
    //     toggleChecklistItem(selectedRadio)
    //     if (radioGroup.type === AWO) {
    //         setCurrentAssessmentFinding(selectedID)
    //     }
    // }

    // const requiredActionClickHandler = () => {
    //     console.log("coming soon")
    // }

    const depth = (undefined === step.depth) ? 0 : step.depth -1

    switch (step.type) {
        // case TYPES.NESTED_CHECKLIST:
        //     return (
        //         <>
        //         <span>{getLabel(step)}</span>
        //         <ul>
        //             {step.items.map(item => (
        //                 <li key={item.id}>
        //                     <CheckListItem  step={item} />
        //                 </li>
        //             ))}
        //         </ul>
        //         </>
        //     )
        case TYPES.CL_HEADING:
            return (
                <span
                    className={`depth-${depth}`}
                    style={{
                        fontSize: "0.75em"
                    }}
                >
                    {getLabel(step)}
                </span>
            )
        case TYPES.ASSESS:
            return (
                <span className={`depth-${depth}`}>
                    <CheckBox
                        step={step}
                        clickHandler={() => assessmentClickHandler(step)}
                        inlineChildren={<CallOutIcon assessment={step} />}
                    />
                    {isChecked(step.id) && <CallOutText assessment={step} /> }
                </span>
            )
        case TYPES.AWO:
            return (
                <>
                    <i className={`depth-${depth}`}>{getLabel(step)}</i> <CallOutIcon assessment={step} />
                    <br />
                    &nbsp; &nbsp;
                    {step.items.map(item => (
                        <label key={item.id}>
                            <input
                                type="radio"
                                name={step.id}
                                checked={isChecked(item.id)}
                                value={item.id}
                                onChange={(event) => awoClickHandler(event, step, item)}
                            />
                            &nbsp; {getLabel(item)} &nbsp;
                        </label>
                    ))}
                    <br />
                    {step.items.map(item => (
                        isChecked(item.id) && <CallOutText key={item.id} assessment={item} />
                    ))}
                </>
            )
        case TYPES.DECISION:
            return (
                <>
                <i
                    className={`depth-${depth}`}
                    style={{
                        fontSize: "0.75ema"
                    }}
                >
                    {getLabel(step)}
                </i>
                <br/>
                <div className={`depth-${depth+1}`}>
                {step.options.map(item => (
                    <label key={item.id}>
                        <input
                            type="radio"
                            name={step.id}
                            checked={isChecked(item.id)}
                            value={item.id}
                            onChange={(event) => decisionClickHandler(event, step, item) }
                        />
                        &nbsp; {getLabel(item)} &nbsp;
                    </label>
                ))}
                </div>
                {/* <br/> */}
                </>
            )
        case TYPES.CL_PROMPT:
            return (<i className={`depth-${depth}`}>{getLabel(step)}</i>)
        default:
            // case 'required-action':
            return (
                <span className={`depth-${depth}`}>
                    <CheckBox
                        step={step}
                        clickHandler={() => toggleChecklistItem(step)}
                    />
                </span>
            )
        }

}


export default CheckListItem;